__turbopack_context__.v({
  "action-preview-label": "SpecialOffer-module-sass-module__Wujppa__action-preview-label",
  "action-preview-label-button": "SpecialOffer-module-sass-module__Wujppa__action-preview-label-button",
  "action-preview-label__arrow": "SpecialOffer-module-sass-module__Wujppa__action-preview-label__arrow",
  "action-preview-label__button": "SpecialOffer-module-sass-module__Wujppa__action-preview-label__button",
  "action-preview-label__description": "SpecialOffer-module-sass-module__Wujppa__action-preview-label__description",
  "action-preview-label__description-wrapper": "SpecialOffer-module-sass-module__Wujppa__action-preview-label__description-wrapper",
  "action-preview-label__link": "SpecialOffer-module-sass-module__Wujppa__action-preview-label__link",
  "description": "SpecialOffer-module-sass-module__Wujppa__description",
});
